"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const icons_material_1 = require("@mui/icons-material");
const material_1 = require("@mui/material");
const CircleRounded_1 = require("@mui/icons-material/CircleRounded");
const index_styles_1 = require("./index.styles");
const CheckButton = (_a) => {
    var { onClick, selected } = _a, props = __rest(_a, ["onClick", "selected"]);
    const { checkContainer, circleContainer, checkIcon, circleIcon } = (0, index_styles_1.default)();
    return selected ? ((0, jsx_runtime_1.jsx)(material_1.IconButton, Object.assign({ onClick: onClick, sx: checkContainer }, props, { children: (0, jsx_runtime_1.jsx)(icons_material_1.CheckRounded, { sx: checkIcon }) }))) : ((0, jsx_runtime_1.jsx)(material_1.IconButton, Object.assign({ sx: circleContainer, onClick: onClick }, props, { children: (0, jsx_runtime_1.jsx)(CircleRounded_1.default, { sx: circleIcon }) })));
};
exports.default = CheckButton;
